package com.xtream.composeapp

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Snackbar
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.ViewModelStore
import androidx.lifecycle.ViewModelStoreOwner
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.navigation3.runtime.NavEntry
import com.xtream.composeapp.data.Screen
import com.xtream.composeapp.presentation.ui.navigation.AppRootNavBarScreen
import com.xtream.composeapp.theme.AppTheme
import com.xtream.composeapp.theme.ComposeUITheme
import com.xtream.composeapp.viewmodel.AppSettingsViewModel
import org.koin.compose.viewmodel.koinViewModel

val LocalSnackbarHostState = compositionLocalOf<SnackbarHostState> {
    error("No SnackbarHostState provided")
}
class AppViewModelStoreOwner : ViewModelStoreOwner {
    override val viewModelStore = ViewModelStore()
}
val LocalAppViewModelStoreOwner =
    staticCompositionLocalOf<ViewModelStoreOwner> {
        error("No AppViewModelStoreOwner provided")
    }
var restartKey by mutableStateOf(0)

fun restartComposeApp() {
    restartKey++
}
@Composable
fun App(
    entryProvider: (Screen) -> NavEntry<Screen>,
      appSettingsViewModel:AppSettingsViewModel = koinViewModel<AppSettingsViewModel>()
 ) {
    //val rootOwner = remember { AppViewModelStoreOwner() }



        val theme by appSettingsViewModel.appThemeFlow.collectAsStateWithLifecycle(  AppTheme.DARK )

            ComposeUITheme(
                theme = theme
            ) {

                val snackbarHostState = remember { SnackbarHostState() }

                CompositionLocalProvider(LocalSnackbarHostState provides snackbarHostState) {
                    @Suppress("UnusedMaterial3ScaffoldPaddingParameter")
                    Scaffold(
                        snackbarHost = {
                            SnackbarHost(snackbarHostState) {
                                Snackbar(
                                    snackbarData = it,
                                    containerColor = MaterialTheme.colorScheme.secondaryContainer,
                                    contentColor = MaterialTheme.colorScheme.onSurface,
                                    //modifier = androidx.compose.ui.Modifier.snackBarView()
                                )

                            }
                        }
                    ) { innerPadding ->
                        //ComposeAccountTvScreen()
                        //MyYoutubePlayer()
                        //TestNewTvChannelsPlayerScreen()

                        //FocusBugRepro()
                        key(restartKey){
                            AppRootNavBarScreen( entryProvider = entryProvider)

                        /* TvPlayerScreen(
                streamId = 1,
                categoryId = 1
            )*/
                        //ComposeSettingsScreen(navKey = Screen.Settings)
                    }
                }
            }
        }

}